// import {
//     $getRoot,
//     $isTextNode,
//     $isElementNode,
//     type EditorState
// } from 'lexical';
// import LatexNode from '../editor/nodes/LatexNode';
// import SimpleLatexNode from '../editor/nodes/SimpleLatexNode';

// Overloads
// export function exportDynamicToPlain(editorState: EditorState): string;
// export function exportDynamicToPlain(html: string): string;

function normalizeString(str: string) {
    return str.replace(/\u00A0/g, ' ').trim();
}

// export function exportDynamicToPlain(input: EditorState | string): string {
export function exportDynamicToPlain(input: string = ''): string {
    // if (typeof input === 'string') {
    // Parse HTML string for text and <latex> tags
    input = normalizeString(input);
    const doc = new DOMParser().parseFromString(input, 'text/html');
    let output = '';
    function walk(node: Node) {
        if (node.nodeType === Node.TEXT_NODE) {
            output += node.textContent;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node as Element;
            if (el.tagName.toLowerCase() === 'latex') {
                output += `<latex>${el.textContent}</latex>`;
            } else if (el.tagName.toLowerCase() === 'img') {
                output += el.outerHTML;
            } else {
                for (const child of Array.from(node.childNodes)) {
                    walk(child);
                }
            }
        }
    }
    walk(doc.body);

    return output.trim();
    // }
    // // Lexical EditorState branch
    // let output = '';
    // input.read(() => {
    //     const root = $getRoot();
    //     for (const child of root.getChildren()) {
    //         if ($isElementNode(child)) {
    //             for (const node of child.getChildren()) {
    //                 if (node instanceof LatexNode || node instanceof SimpleLatexNode) {
    //                     output += `<latex>${node.__latex}</latex>`;
    //                 } else if ($isTextNode(node)) {
    //                     output += node.getTextContent();
    //                 }
    //             }
    //         }
    //     }
    // });
    // return output.trim();
}
